import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { SectionVeil } from "../components/SectionVeil";
import { HomeFeatures } from "../components/home/HomeFeatures";
import { HomeDorothyTeaser } from "../components/home/HomeDorothyTeaser";
import { HomeLiveCta } from "../components/home/HomeLiveCta";
import { HomePartnerCta } from "../components/home/HomePartnerCta";
import { HomeParticipationHub } from "../components/participation/HomeParticipationHub";

export function HomePage() {
  return (
    <>
      <Hero />
      <SectionVeil />
      <Marquee />
      <SectionVeil />
      <HomeParticipationHub />
      <SectionVeil />
      <HomeFeatures />
      <SectionVeil />
      <HomeDorothyTeaser />
      <SectionVeil />
      <HomeLiveCta />
      <SectionVeil />
      <HomePartnerCta />
    </>
  );
}
